import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowDownLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-down-left"><path d="M5.75 8.75V18.25H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18.0001 6L6.3999 17.6002" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowDownLeft;
